export interface Manga {
  id: string;
  title: string;
  author: string;
  cover: string;
  coverWidth: number;
  coverHeight: number;
  description: string;
  status: string;
  latestChapter: string;
  updateDate: string;
  categories: string[];
  rating: number;
  views: number;
  isHot: boolean;
  isFeatured: boolean;
  isNew: boolean;
}

export const allManga: Manga[] = [
  {
    id: 'manga-1',
    title: '满溢游泳池',
    author: '夏日晴空',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20swimming%20pool%20scene%20with%20two%20teenagers%20swimming%2C%20bright%20summer%20sunlight%20reflecting%20on%20blue%20water%2C%20school%20swimming%20pool%20setting%2C%20youthful%20energy%2C%20clean%20anime%20art%20style%2C%20white%20background%2C%20vibrant%20colors%2C%20high%20contrast%2C%20professional%20manga%20cover%20quality&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '高中二年级的林晓雨加入了学校的游泳社，本以为只是普通的社团活动，却在泳池边遇到了那个改变她整个夏天的男生。成绩优异却性格冷漠的游泳健将陈默，在一次次训练中，两颗年轻的心逐渐靠近……一场关于青春、梦想与初恋的泳池故事就此展开。',
    status: '连载中',
    latestChapter: '第48话 夏日终曲',
    updateDate: '2026-07-08',
    categories: ['cat-1', 'cat-2', 'cat-3'],
    rating: 4.8,
    views: 1286000,
    isHot: true,
    isFeatured: true,
    isNew: false,
  },
  {
    id: 'manga-2',
    title: '篮球少年无悔',
    author: '铁拳阿杰',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20illustration%20of%20a%20basketball%20player%20jumping%20for%20a%20dunk%20in%20a%20school%20gymnasium%2C%20dynamic%20action%20pose%2C%20orange%20basketball%2C%20sweat%20drops%2C%20intense%20facial%20expression%2C%20clean%20anime%20art%20style%2C%20white%20background%2C%20professional%20manga%20cover%20quality&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '身高不足一米七的周阳，凭借惊人的弹跳力和永不言败的精神闯入了高中篮球界。面对强大的对手和自身的局限，他用汗水书写属于自己的篮球传奇。',
    status: '连载中',
    latestChapter: '第156话 最后一投',
    updateDate: '2026-07-07',
    categories: ['cat-2', 'cat-1'],
    rating: 4.7,
    views: 982000,
    isHot: true,
    isFeatured: true,
    isNew: false,
  },
  {
    id: 'manga-3',
    title: '初恋这件小事',
    author: '雨后微凉',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20a%20shy%20girl%20and%20boy%20standing%20under%20cherry%20blossom%20tree%20in%20spring%2C%20pink%20petals%20falling%2C%20school%20uniforms%2C%20blushing%20faces%2C%20soft%20romantic%20atmosphere%2C%20clean%20shojo%20manga%20art%20style%2C%20white%20background%2C%20gentle%20colors&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '从未谈过恋爱的大一新生苏小曼，在图书馆邂逅了温柔学长顾言。一封错递的情书，一场美丽的误会，让两个原本毫无交集的人走到了一起。',
    status: '已完结',
    latestChapter: '第120话 我们的未来（完结）',
    updateDate: '2026-06-30',
    categories: ['cat-3', 'cat-1'],
    rating: 4.9,
    views: 1580000,
    isHot: true,
    isFeatured: false,
    isNew: false,
  },
  {
    id: 'manga-4',
    title: '游泳部的日常',
    author: '水池边的猫',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20manga%20style%20illustration%20of%20quirky%20swimming%20club%20members%20goofing%20around%20poolside%2C%20exaggerated%20chibi%20expressions%2C%20water%20splashes%2C%20colorful%20swimsuits%2C%20comedy%20slice%20of%20life%20vibe%2C%20clean%20anime%20art%20style%2C%20white%20background%2C%20bright%20fun%20colors&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '阳光开朗的游泳部日常！不会游泳却当了游泳部经理的废柴女主，加上各有特色的游泳部成员们，每天都充满了爆笑与感动。',
    status: '连载中',
    latestChapter: '第89话 泳池派对的陷阱',
    updateDate: '2026-07-08',
    categories: ['cat-4', 'cat-2', 'cat-1'],
    rating: 4.5,
    views: 756000,
    isHot: false,
    isFeatured: false,
    isNew: true,
  },
  {
    id: 'manga-5',
    title: '夏日蝉鸣时',
    author: '墨染青衫',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20a%20girl%20sitting%20by%20classroom%20window%20during%20summer%2C%20sunlight%20streaming%20through%20curtains%2C%20cicada%20summer%20vibe%2C%20nostalgic%20atmosphere%2C%20school%20desk%20and%20textbooks%2C%20clean%20seinen%20manga%20art%20style%2C%20white%20background%2C%20warm%20golden%20lighting&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '高二暑假，成绩优异的沈默被安排辅导转学生林听。在蝉鸣不止的教室里，两颗孤寂的心找到了彼此的共鸣。这是一个关于成长与救赎的夏日物语。',
    status: '已完结',
    latestChapter: '第60话 再见了，那个夏天（完结）',
    updateDate: '2026-07-05',
    categories: ['cat-1', 'cat-3'],
    rating: 4.6,
    views: 845000,
    isHot: true,
    isFeatured: false,
    isNew: false,
  },
  {
    id: 'manga-6',
    title: '斗罗大陆外传',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20fantasy%20warrior%20with%20glowing%20martial%20arts%20aura%2C%20ancient%20Chinese%20costume%2C%20dragon%20spirit%20behind%2C%20epic%20atmosphere%2C%20dynamic%20battle%20pose%2C%20clean%20manhua%20art%20style%2C%20white%20background%2C%20dramatic%20lighting&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '在斗罗大陆的广阔世界中，一位少年的武魂觉醒，踏上了成为封号斗罗的传奇旅程。魂环、魂骨、魂技的奇幻冒险，热血与感动交织。',
    status: '连载中',
    latestChapter: '第320话 海神之怒',
    updateDate: '2026-07-08',
    categories: ['cat-5', 'cat-7'],
    rating: 4.9,
    views: 2350000,
    isHot: true,
    isFeatured: true,
    isNew: false,
  },
  {
    id: 'manga-7',
    title: '名侦探柯北',
    author: '推理狂人',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20a%20young%20detective%20in%20trench%20coat%20holding%20magnifying%20glass%2C%20mysterious%20silhouette%20in%20background%2C%20crime%20scene%20elements%2C%20dramatic%20shadows%2C%20clean%20anime%20art%20style%2C%20white%20background%2C%20noir%20atmosphere&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '高中生侦探工藤新二，在一次案件中被迫服下神秘药物，身体缩小成了小学生的模样。从此化名"江户川柯北"，在暗中继续追查真相。',
    status: '连载中',
    latestChapter: '第1089话 红色密码',
    updateDate: '2026-07-06',
    categories: ['cat-6'],
    rating: 4.7,
    views: 1890000,
    isHot: true,
    isFeatured: false,
    isNew: false,
  },
  {
    id: 'manga-8',
    title: '星纪元·重启',
    author: '银河旅人',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20style%20illustration%20of%20a%20futuristic%20soldier%20in%20powered%20armor%20with%20energy%20weapon%2C%20spaceship%20in%20background%2C%20neon%20cityscape%2C%20cyberpunk%20vibe%2C%20clean%20digital%20art%20style%2C%20white%20background%2C%20holographic%20lighting&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '公元2245年，人类文明遭遇前所未有的危机。主角零号从冷冻舱中苏醒，发现自己身处一个完全陌生的未来世界，他必须找到重启文明的方法。',
    status: '连载中',
    latestChapter: '第72话 零点协议',
    updateDate: '2026-07-04',
    categories: ['cat-8', 'cat-5'],
    rating: 4.4,
    views: 426000,
    isHot: false,
    isFeatured: false,
    isNew: false,
  },
  {
    id: 'manga-9',
    title: '仙王的日常',
    author: '枯玄君',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20style%20illustration%20of%20a%20young%20immortal%20cultivator%20in%20flowing%20white%20robes%2C%20floating%20sword%2C%20misty%20mountain%20peaks%2C%20ancient%20Chinese%20aesthetic%2C%20clean%20manhua%20art%20style%2C%20white%20background%2C%20ethereal%20atmosphere&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '修仙界最强仙王转生到现代都市，本想低调生活却总被意外卷入各种事件。无敌流爆笑修仙日常，看仙王如何在现代社会中"低调"生活。',
    status: '连载中',
    latestChapter: '第210话 低调的极限',
    updateDate: '2026-07-08',
    categories: ['cat-7', 'cat-4'],
    rating: 4.8,
    views: 1650000,
    isHot: true,
    isFeatured: false,
    isNew: false,
  },
  {
    id: 'manga-10',
    title: '甜品店的恋爱',
    author: '草莓布丁',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20a%20cute%20girl%20and%20boy%20working%20in%20a%20dessert%20shop%2C%20cakes%20and%20pastries%20displayed%2C%20warm%20lighting%2C%20romantic%20cafe%20atmosphere%2C%20clean%20shojo%20manga%20art%20style%2C%20white%20background%2C%20sweet%20pink%20accents&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '在街角的一家小小甜品店里，面包师少女遇见了每天准时来买可颂的上班族青年。一块提拉米苏，一杯拿铁，甜蜜的恋爱在烘焙的香气中慢慢发酵。',
    status: '连载中',
    latestChapter: '第35话 心形马卡龙',
    updateDate: '2026-07-07',
    categories: ['cat-3', 'cat-4'],
    rating: 4.6,
    views: 578000,
    isHot: false,
    isFeatured: false,
    isNew: true,
  },
  {
    id: 'manga-11',
    title: '灵魂画师',
    author: '笔尖上的梦',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20illustration%20of%20a%20young%20artist%20holding%20paintbrush%20with%20magical%20colors%20swirling%20around%2C%20canvas%20with%20glowing%20painting%2C%20fantasy%20art%20studio%2C%20clean%20seinen%20art%20style%2C%20white%20background%2C%20vibrant%20color%20palette&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '拥有能让画作变成现实的神奇能力，少年画家白羽被卷入了一场关于艺术与灵魂的奇幻冒险。每一笔都是生命，每一幅画都是世界。',
    status: '连载中',
    latestChapter: '第56话 最后一笔',
    updateDate: '2026-07-03',
    categories: ['cat-5'],
    rating: 4.3,
    views: 312000,
    isHot: false,
    isFeatured: false,
    isNew: false,
  },
  {
    id: 'manga-12',
    title: '消失的她',
    author: '午夜墨迹',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20a%20mysterious%20girl%20disappearing%20into%20shadows%2C%20half%20visible%20face%2C%20dark%20alleyway%2C%20rainy%20night%2C%20thriller%20atmosphere%2C%20clean%20anime%20art%20style%2C%20white%20background%2C%20high%20contrast%20noir&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '一个下着雨的夜晚，大学生许愿的女友突然失踪。在追查真相的过程中，一个又一个惊人的秘密浮出水面。每个人都在说谎，真相远比想象的更加可怕。',
    status: '连载中',
    latestChapter: '第42话 镜中的陌生人',
    updateDate: '2026-07-06',
    categories: ['cat-6'],
    rating: 4.5,
    views: 638000,
    isHot: false,
    isFeatured: false,
    isNew: false,
  },
];

export const getMangaByCategory = (categoryId: string): Manga[] => {
  return allManga.filter((m) => m.categories.includes(categoryId));
};

export const getMangaById = (id: string): Manga | undefined => {
  return allManga.find((m) => m.id === id);
};

export const getHotManga = (): Manga[] => {
  return allManga.filter((m) => m.isHot);
};

export const getFeaturedManga = (): Manga[] => {
  return allManga.filter((m) => m.isFeatured);
};

export const getNewManga = (): Manga[] => {
  return allManga.filter((m) => m.isNew);
};